<template >
    <div class="font-transform">
        <a id="decrease" href="#" v-on:click="decrement(e)" aria-label="Decrease font size" class="linkinfo">-A<span>Decrease font size</span></a>&nbsp;&nbsp;
        <a id="reset" href="#" @click="reset(e)" aria-label="Reset font size" class="linkinfo">A<span>Reset font size</span></a>&nbsp;
        <a id="increase" href="#" v-on:click="increment(e)" aria-label="Increase font size" class="linkinfo">+A<span>Increase font size</span></a> 
    </div>
</template>

<script>
export default {
    name: 'TranformFonts',
    data(){
        return{
            origFont:10,
            incFont:10,
            toggleFlag:0,
            icounterFlag:0,
            dcounterFlag:0,
            fontSize:''
        };        
    },   
    
	methods:{
        reset:function(e){                
                $('#reset').attr('role','alert');            
                this.changeElementsList(3,this.origFont,this.incFont);
                this.incFont=10;
                this.icounterFlag=0;
                this.dcounterFlag=0;                
                e.preventDefault();
            },

        increment:function(e){            
            $('#increase').attr('role','alert');               
            this.icounterFlag+=1;
            if(this.icounterFlag<=2){
                this.changeElementsList(1);
                this.incFont+=1;
                this.toggleFlag=0;                
            }else{
                return false;
            }            
            e.preventDefault();
        },
        
        decrement:function(e){
            $('#decrease').attr('role','alert');                   
            if(this.icounterFlag!=0){
                this.icounterFlag-=1;
                this.changeElementsList(2);
                this.incFont-=1;
                this.toggleFlag=1;
            }else{
                this.dcounterFlag+=1;
                if(this.dcounterFlag<=2){
                    this.changeElementsList(2);
                    this.incFont-=1;
                    this.toggleFlag=1;     
                }else{
                    return false;    
                }
            }            
            e.preventDefault();               
        },

        changeElementsList(type,origFont,incFont){
            var list = document.querySelectorAll("input,select,a,h1,h2,ul,li, .desc > p, .desc > span, label, .archives > div");
            var index;
            for (index = 0; index < list.length; ++index) {
                var currentSize =  $(list[index]).css('font-size');
                if(type==1){                        
                    var size = parseInt(currentSize) + (1) + "px";
                }else if(type==2){
                    var size = parseInt(currentSize) - (1) + "px";        
                }else if(type==3){
                    if(this.toggle==1) {                 
                        var size = parseInt(currentSize) + (parseInt(origFont)-parseInt(incFont)) + "px";
                    }else{
                        var size = parseInt(currentSize) - (parseInt(incFont)-parseInt(origFont)) + "px";  
                    }    
                }
                list[index].style.fontSize = size; 
            }
        }
    }
};
</script>
<style scoped>
.font-transform a{
    font-size:15px !important;
}
#colorlib-aside .colorlib-footer a.linkinfo span {
    display: none !important;
}
a.linkinfo:hover span, a.linkinfo:focus span, a.linkinfo:active span {
    display: block !important;
    position: absolute;
    top: 1.2em;
    left: -4em;
    width: 6em;
    border: 1px solid #000;
    background-color: #F4F4F4;
    color: #000;
    text-align: center;
    line-height: 20px;
    z-index: 99;
}
@media screen and (max-width: 480px){
    a.linkinfo:hover span, a.linkinfo:focus span, a.linkinfo:active span {
        line-height: 15px;
        font-size: 12px;
    }
}
</style>